import { defaultProps } from 'recompose';

import { SupportWidget } from '../../widgets';
import { svg } from 'constants';

import CommonButton from './CommonButton';

export default defaultProps({
  tooltipText: 'Contact Support',
  icon: svg.support,
  widget: SupportWidget,
})(CommonButton);

